import { z } from "zod";
import { campaignFormSchema } from "./campaign.form";
import { giftSchema } from "./campaign.gift";

const actionSchema = z.object({
  id: z.string().optional(),
  type: z.string(),
  target: z.string().optional(),
});

export const campaignSaveSchema = campaignFormSchema.extend({
  gifts: z.array(giftSchema),
  actions: z.array(actionSchema),
  isProxy: z.boolean(),
  // false while the wizard hasn't reached the gifts step yet
  checkGifts: z.boolean().default(true),
}).superRefine((data, ctx) => {
  if (data.isProxy) return;

  if (!data.actions.length) {
    ctx.addIssue({ code: "custom", message: "errors.actions.empty", path: ["actions"] });
  }

  if (!data.checkGifts) return;

  if (!data.gifts.length) {
    ctx.addIssue({ code: "custom", message: "errors.gifts.empty", path: ["gifts"] });
  }

  const hasLoss = data.gifts.some(g => g.type === "LOSS");
  const hasUnlimited = data.gifts.some(g => typeof g.limit === "number" && g.limit <= -1);
  if (!hasLoss && !hasUnlimited) {
    ctx.addIssue({ code: "custom", message: "errors.gifts.missing_unlimited", path: ["gifts"] });
  }

  const hasPromoGift = data.gifts.some(g => g.type === "PROMO_CODE");
  const hasPromoCode = data.promoCodes.some(p => p.value?.trim());
  if (hasPromoGift && !hasPromoCode) {
    ctx.addIssue({ code: "custom", message: "errors.promoCodes.empty", path: ["promoCodes"] });
  }
});

export type CampaignSavePayload = z.infer<typeof campaignSaveSchema>;
